import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import SuperAdminNavbar from "./NavBars/SuperAdminNavbar";
import ClinetServiceNavbar from "./NavBars/ClinetServiceNavbar";
import Navbar from "./NavBars/Navbar";
import TalnetNavBar from './NavBars/TalnetNavBar';
import FinanceNavbar from './NavBars/FinanceNavbar';

const AppNavbar = () => {
  const { userRole } = useAuth();

  switch (userRole) {
    case 'superadmin':
      return <SuperAdminNavbar />;
    case 'clientService':
      return <ClinetServiceNavbar />;
    case 'planning':
      return <ClinetServiceNavbar />;
    case 'talent':
      return <TalnetNavBar />;
    case 'finance':
      return <FinanceNavbar />;
    default:
      return <Navbar />;
  }
};

export default AppNavbar;